import { render, staticRenderFns } from "./ContMyAccessComponent.vue?vue&type=template&id=63e16e2a&scoped=true&lang=pug"
import script from "./ContMyAccessComponent.vue?vue&type=script&lang=js"
export * from "./ContMyAccessComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e16e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e16e2a')) {
      api.createRecord('63e16e2a', component.options)
    } else {
      api.reload('63e16e2a', component.options)
    }
    module.hot.accept("./ContMyAccessComponent.vue?vue&type=template&id=63e16e2a&scoped=true&lang=pug", function () {
      api.rerender('63e16e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyAccessComponent.vue"
export default component.exports